module.exports = __webpack_public_path__ + "static/restaurant-fda34e6c850f019125243c2b4c09a0af.jpg";